module.exports = __webpack_public_path__ + "static/media/93.df8984ce.gif";